<template>
  <div class="btn-preorder">
    <a :href="getPreorderURL" @click="movePreorder()">사전예약</a>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  computed: {
    ...mapState(["contentsData", "country"]),
    ...mapGetters(["getPreorderURL"]),
  },
};
</script>
<style lang="scss">
/*
  .btn-preorder{
    @include position(
      $position: absolute,
      $width: 290px,
      $height: 224px,
      $bottom: 0,
      $right: 0
    );
    @include hide-text;

    .ko &{
      @include bg($bg: "../assets/img/ko/btn_preorder_pc_ko.png");
    }
    .en &{
      @include bg($bg: "../assets/img/en/btn_preorder_pc_en.png");
    }
    .ja &{
      @include bg($bg: "../assets/img/ja/btn_preorder_pc_ja.png");
    }
    .zh &{
      @include bg($bg: "../assets/img/zh/btn_preorder_pc_zh.png");
    }
    background-position: 20px 7px;
    z-index: 30;

    a {
      width: 100%;
      height: 100%;
      display: block;
      @include hide-text();
      &:before {
        opacity: 0;
        display: inline-block;
        content: "";
        .ko & {
          @include bg($bg: "../assets/img/ko/btn_preorder_pc_ko.png");
        }
        .en & {
          @include bg($bg: "../assets/img/en/btn_preorder_pc_en.png");
        }
        .ja & {
          @include bg($bg: "../assets/img/ja/btn_preorder_pc_ja.png");
        }
        .zh & {
          @include bg($bg: "../assets/img/zh/btn_preorder_pc_zh.png");
        }
        background-position: 20px -243px;
        @include position(
          $position: absolute,
          $width: 290px,
          $height: 224px,
          $bottom: 0,
          $right: 0
        );
        transition: 0.3s;
      }
      &:hover:before {
        opacity: 1;
      }
    }
    @include bp(tablet) {
      width: 140.5px;
      height: 137px;
      .ko &{
        @include bg($bg: "../assets/img/ko/btn_preorder_m.png");
      }
      .en &{
        @include bg($bg: "../assets/img/en/btn_preorder_m_en.png");
      }
      .ja &{
        @include bg($bg: "../assets/img/ja/btn_preorder_m_ja.png");
      }
      .zh &{
        @include bg($bg: "../assets/img/zh/btn_preorder_m_zh.png");
      }

      background-size: contain;
      a {
        &:before {
          display: none;
        }
      }
    }
  }*/
:lang(en) {
  .btn-preorder {
    @include bg($bg: "../assets/img/en/btn_preorder_pc_en.png");
    background-position: 20px 7px;
    a {
      &:before {
        @include bg($bg: "../assets/img/en/btn_preorder_pc_en.png");
        background-position: 20px -243px;
      }
    }
    @include bp(tablet) {
      width: 140.5px;
      height: 137px;
      @include bg($bg: "../assets/img/en/btn_preorder_m_en.png");

      a {
        &:before {
          display: none;
        }
      }
    }
  }
}
:lang(ja) {
  .btn-preorder {
    @include bg($bg: "../assets/img/ja/btn_preorder_pc_ja.png");
    background-position: 20px 7px;
    @include bp(tablet) {
      right: -3px !important;
    }

    a {
      &:before {
        @include bg($bg: "../assets/img/ja/btn_preorder_pc_ja.png");
        background-position: 20px -243px;
      }
    }
    @include bp(tablet) {
      width: 140.5px;
      height: 137px;
      @include bg($bg: "../assets/img/ja/btn_preorder_m_ja.png");

      a {
        &:before {
          display: none;
        }
      }
    }
  }
}
:lang(zh) {
  .btn-preorder {
    @include bg($bg: "../assets/img/zh/btn_preorder_pc_zh.png");
    background-position: 20px 7px;

    a {
      &:before {
        @include bg($bg: "../assets/img/zh/btn_preorder_pc_zh.png");
        background-position: 20px -243px;
      }
    }
    @include bp(tablet) {
      width: 140.5px;
      height: 137px;
      @include bg($bg: "../assets/img/zh/btn_preorder_m_zh.png");

      a {
        &:before {
          display: none;
        }
      }
    }
  }
}
.btn-preorder {
  @include position(
    $position: absolute,
    $width: 290px,
    $height: 224px,
    $bottom: 0,
    $right: 10px
  );
  @include hide-text;
  @include bg($bg: "../assets/img/ko/btn_preorder_pc_ko.png");
  background-position: 20px 7px;
  z-index: 30;
  @include bp(tablet) {
    right: 0px !important;
  }

  a {
    width: 100%;
    height: 100%;
    display: block;
    &:before {
      opacity: 0;
      display: inline-block;
      content: "";
      @include bg($bg: "../assets/img/ko/btn_preorder_pc_ko.png");
      background-position: 20px -243px;
      @include position(
        $position: absolute,
        $width: 290px,
        $height: 224px,
        $bottom: 0,
        $right: 0
      );
      transition: 0.3s;
    }
    &:hover:before {
      opacity: 1;
      //background-position: 10px -249px !important;
      //z-index: 11 !important;
      //background-position-y: -245px !important;
    }
  }
  @include bp(tablet) {
    width: 140.5px;
    height: 137px;
    @include bg($bg: "../assets/img/ko/btn_preorder_m.png");
    background-size: contain;
    a {
      &:before {
        display: none;
      }
    }
  }
}
</style>
